import {RouteObject, RouterContextProvider, redirect} from 'react-router';

import {getAvailableActiveTariffs} from 'src/containers/Tariffs';
import {EFeatureFlag, userEndpoints} from 'src/containers/User';
import {getDispatch} from 'src/routerContext';

import {EChannelsTabs} from './definitions';

const checkVarificationAccess = async (context: RouterContextProvider) => {
  const dispatch = getDispatch(context);
  const {data: featureFlags} = await dispatch(userEndpoints.getFeatureFlags.initiate());

  if (!featureFlags?.[EFeatureFlag.WHATSAPP_PARTNER_VERIFICATION]) {
    return false;
  }

  const {data: whatsAppTariffs = []} = await dispatch(getAvailableActiveTariffs.initiate());

  return !!whatsAppTariffs.length;
};

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(EChannelsTabs.LIST),
  },
  {
    path: EChannelsTabs.LIST,
    lazy: async () => ({
      Component: (await import('./List')).ChannelsList,
    }),
  },
  {
    path: EChannelsTabs.VERIFICATION,
    loader: async ({context}) => {
      const hasAccess = await checkVarificationAccess(context);

      if (hasAccess) {
        return null;
      }

      redirect(EChannelsTabs.LIST);
    },
    lazy: async () => ({
      Component: (await import('./Verification')).Verification,
    }),
  },
];

export const channelsRoutes: RouteObject = {
  loader: async ({context}) => {
    const availableTabs: EChannelsTabs[] = [EChannelsTabs.LIST];

    const hasAccess = await checkVarificationAccess(context);

    if (hasAccess) {
      availableTabs.push(EChannelsTabs.VERIFICATION);
    }

    return {
      tabs: availableTabs,
    };
  },
  children,
};
